var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThirdPlaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0.732429C15.5235 0.285847 16.4765 0.285848 17.25 0.73243L29.9054 8.03905C30.6789 8.48564 31.1554 9.31095 31.1554 10.2041V24.8174C31.1554 25.7105 30.6789 26.5358 29.9054 26.9824L17.25 34.2891C16.4765 34.7356 15.5235 34.7356 14.75 34.2891L2.09455 26.9824C1.32105 26.5358 0.844556 25.7105 0.844556 24.8174V10.2041C0.844556 9.31095 1.32105 8.48564 2.09456 8.03905L14.75 0.732429Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0.732429C15.5235 0.285847 16.4765 0.285848 17.25 0.73243L29.9054 8.03905C30.6789 8.48564 31.1554 9.31095 31.1554 10.2041V24.8174C31.1554 25.7105 30.6789 26.5358 29.9054 26.9824L17.25 34.2891C16.4765 34.7356 15.5235 34.7356 14.75 34.2891L2.09455 26.9824C1.32105 26.5358 0.844556 25.7105 0.844556 24.8174V10.2041C0.844556 9.31095 1.32105 8.48564 2.09456 8.03905L14.75 0.732429Z",
    fill: "url(#paint0_linear_1918_2836)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7502 4.06544C15.5237 3.61886 16.4767 3.61886 17.2502 4.06544L27.0189 9.70539C27.7924 10.152 28.2689 10.9773 28.2689 11.8705V23.1504C28.2689 24.0435 27.7924 24.8689 27.0189 25.3154L17.2502 30.9554C16.4767 31.402 15.5237 31.402 14.7502 30.9554L4.98147 25.3154C4.20797 24.8689 3.73147 24.0435 3.73147 23.1504V11.8705C3.73147 10.9773 4.20797 10.152 4.98147 9.7054L14.7502 4.06544Z",
    fill: "url(#paint1_linear_1918_2836)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.7502 4.06544C15.5237 3.61886 16.4767 3.61886 17.2502 4.06544L27.0189 9.70539C27.7924 10.152 28.2689 10.9773 28.2689 11.8705V23.1504C28.2689 24.0435 27.7924 24.8689 27.0189 25.3154L17.2502 30.9554C16.4767 31.402 15.5237 31.402 14.7502 30.9554L4.98147 25.3154C4.20797 24.8689 3.73147 24.0435 3.73147 23.1504V11.8705C3.73147 10.9773 4.20797 10.152 4.98147 9.7054L14.7502 4.06544Z",
    fill: "url(#paint2_radial_1918_2836)",
    fillOpacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3068 17.5348H13.3628V15.6628C13.3988 15.6268 13.4348 15.6088 13.4708 15.5728L16.3688 13.0348H11.3468V10.4788H20.0228V12.8008L17.2148 15.2668C19.0148 15.8068 20.4728 17.2468 20.4728 19.5148C20.4728 22.3228 18.2048 24.0328 15.5048 24.0328C12.9128 24.0328 10.7348 22.4488 10.7348 19.4428H13.6148C13.6148 20.7568 14.4068 21.4588 15.5768 21.4588C16.7108 21.4588 17.4848 20.6848 17.4848 19.4968C17.4848 18.4348 16.8728 17.5348 15.3068 17.5348Z",
    fill: "#FDFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1918_2836",
    x1: -0.541423,
    y1: 8.55312,
    x2: 36.8356,
    y2: 33.0617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648623,
    stopColor: "#99DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234907,
    stopColor: "#BDDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#D0C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747552,
    stopColor: "#C4C1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913698,
    stopColor: "#848DC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1918_2836",
    x1: -6.7822,
    y1: 2.50567,
    x2: 33.4306,
    y2: 34.4468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.254476,
    stopColor: "#FFF5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#F3AA80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913698,
    stopColor: "#C5655B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1918_2836",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0002 17.5104) scale(28.7308 23.2976)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A4A4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51406,
    stopColor: "#BB0FA4",
    stopOpacity: 0.498
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdPlaceIcon);
export default __webpack_public_path__ + "static/media/thirdPlaceIcon.ab79202415dc5f0ffef9f939c84859cf.svg";
export { ForwardRef as ReactComponent };